import React, { Component } from 'react'
import { SortableContainer, SortableElement } from '@adalo/react-sortable-hoc'

import { IconButton } from 'components/Shared/Icon'
import { GroupedAccordion } from 'components/Shared/Accordion'

import SimpleTextControl from '../SimpleTextControl'

class FieldItem extends Component {
  handleChange = field => {
    const { fieldIndex, onChange } = this.props

    onChange(fieldIndex, field)
  }

  handleDelete = () => {
    const { fieldIndex, onDelete } = this.props

    onDelete(fieldIndex)
  }

  renderChildren = () => {
    const { field } = this.props

    return (
      <div onMouseDown={this.handleMouseDown}>
        <SimpleTextControl
          displayName="Description"
          value={field.label}
          name="label"
          onChange={this.handleChange}
        />
      </div>
    )
  }

  getCollectionField = () => {
    const { field, datasourceCollection } = this.props

    return datasourceCollection.fields[field.fieldId]
  }

  renderTitle = () => {
    const field = this.getCollectionField()

    return (
      <div className="form-inspect-field-title">
        <span>{(field && field.name) || '[Deleted Column]'}</span>
        <IconButton type="trash-small" onClick={this.handleDelete} />
      </div>
    )
  }

  render() {
    const { field, datasourceCollection } = this.props

    if (!field || !datasourceCollection) {
      return null
    }

    return (
      <div className="form-inspect-field-wrapper">
        <GroupedAccordion
          boxed
          className="form-inspect-field"
          group="form-inspect-field"
          itemId={field.fieldId}
          title={this.renderTitle()}
          renderChildren={() => this.renderChildren()}
        />
      </div>
    )
  }
}

class FieldItemsList extends Component {
  render() {
    const {
      items,
      collection,
      datasource,
      onChange,
      onDelete,
      appId,
      object,
      componentId,
    } = this.props

    if (!datasource) {
      return null
    }

    return (
      <div>
        {items.map((field, i) => (
          <SortableFieldItem
            key={field.fieldId}
            appId={appId}
            object={object}
            componentId={componentId}
            fieldIndex={i}
            index={i}
            field={field}
            datasource={datasource}
            datasourceCollection={collection}
            onChange={onChange}
            onDelete={onDelete}
          />
        ))}
      </div>
    )
  }
}

const SortableFieldItem = SortableElement(FieldItem)

export const SortableFieldItemsList = SortableContainer(FieldItemsList)
